import { BrowserRouter } from "react-router-dom";
import { Routes, Route } from "react-router";
import { TopNav } from "@/components/layout/top-nav";
import { Footer } from "@/components/layout/footer";
import { Landing } from "@/pages/landing";
import { About } from "@/pages/about";
import { Product } from "@/pages/product";
import { Community } from "@/pages/community";
import "./index.css";

export function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen flex flex-col">
        <TopNav />
        <main className="flex-1 bg-gradient-to-tr from-primary/10 to-background min-h-screen">
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/product" element={<Product />} />
            <Route path="/community" element={<Community />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
